import React from "react";
import { Button, Divider, Image, Modal } from "antd";
import { FaCrown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setVisibleMOKBModalSub } from "../../../store/components/Reports.slice";

import { HiOutlineLightBulb } from "react-icons/hi";
import { IoMdGlobe } from "react-icons/io";
import { VscOpenPreview } from "react-icons/vsc";
import nosubscription from "../../../images/insights/OI_proversionimage.svg";

function NoSubMOKBModal() {
    const dispatch = useDispatch();
    const { visibleMOKBModalSub: {
        visible
    } } = useSelector((state) => state.reports);

    return (<Modal
        centered
        className="report--insights--nosubsmodal"
        open={visible}
        title={null}
        footer={null}
        onCancel={() => {
            dispatch(setVisibleMOKBModalSub({
                data: null,
                visible: false
            }));
        }}
        width="180mm"
    >
        <div
            style={{ height: "100mm" }}
            className="nosubscription result"
        >
            <div className="nosubscription-imagecont">
                <Image src={nosubscription} preview={false} />
            </div>
            <div className="nosubscription-detailscont">
                <div className="nosubscription-flexjustify">
                    <span className="nosubscription-title">
                        Try ONE Intelligence
                    </span>
                    <span className="nosubscription-tag">
                        PRO
                    </span>
                </div>
                <div className="nosubscription-flexjustify">
                    <span className="nosubscription-boderbottom" />
                </div>
                <div className="text-center">Build Your Own Knowledge Base</div>
                <div className="nosubscription-flexjustify">
                    <Button type="primary" style={{ marginTop: "3mm" }} onClick={() => {
                        window.open("mailto: onemarket@sqreem.com")
                    }}>
                        <FaCrown style={{ marginRight: "2mm" }} />
                        <span>Upgrade Plan</span>
                    </Button>
                </div>
            </div>
        </div>
    </Modal>
    );
}

export default NoSubMOKBModal;
